<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-card
    class="d-flex flex-column justify-end"
    color="transparent"
    elevation="0"
    style="position:relative"
    tile
  >
    <apex-chart
      v-if="graphIsReady"
      :options="options"
      :series="series"
      height="350"
      type="bar"
    />
  </v-card>
</template>
<script>

import i18n from '@/i18n'

export default {
  name: 'OrderTypeChart',
  props: {
    totalPersonCost: {},
    totalHouseCost: {},
    totalHydropowerCost: {},
    totalMaterialCost: {},
    totalTaxCost: {}
  },
  data: function () {
    return {
      series: [],
      options: {},
      graphIsReady: false
    }
  },
  mounted () {
    this.initGraph()
  },
  methods: {
    initGraph: async function () {
      this.graphIsReady = false
      const totalCost = this.totalPersonCost + this.totalHouseCost + this.totalHydropowerCost + this.totalMaterialCost + this.totalTaxCost
      const data = [
        {
          name: this.$t('PersonnelExpenses'),
          value: ((this.totalPersonCost / totalCost) * 100).toFixed(2)
        },
        {
          name: this.$t('Rent'),
          value: ((this.totalHouseCost / totalCost) * 100).toFixed(2)
        },
        {
          name: this.$t('Hydropower'),
          value: ((this.totalHydropowerCost / totalCost) * 100).toFixed(2)
        },
        {
          name: this.$t('RawMaterial'),
          value: ((this.totalMaterialCost / totalCost) * 100).toFixed(2)
        },
        {
          name: this.$t('tax'),
          value: ((this.totalTaxCost / totalCost) * 100).toFixed(2)
        }
      ].map(it => {
        return {
          x: it.name,
          y: it.value
        }
      })
      this.series = [
        {
          name: this.$t('FixedCosts'),
          data
        }
      ]

      this.options = {
        fill: {
          colors: [
            '#8a8a8a',
            '#3a3a3a',
            '#bababa',
            '#fbdc46'
          ]
        },
        plotOptions: {
          bar: {
            columnWidth: '90%',
            distributed: true,
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }

        },

        grid: {
          show: false
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: function (val) {
              return i18n.t('PercentOfTotalSales', { analysisGraphVal: val + '%' })
            }
          }
        },
        yaxis: {
          show: true,
          axisBorder: {
            show: false
          }
        },
        xaxis: {
          show: false,
          type: 'category',
          labels: {
            formatter: function (val) {
              return val + '%'
            }
          },
          axisTicks: {
            show: false
          }
        }

      }
      this.graphIsReady = true
    }
  }
}
</script>

<style scoped>

</style>
